// extracted by css-extract-rspack-plugin
export default {"riverFootstepsImage":"FlexSuiteRiverFootsteps-module__riverFootstepsImage__ClKrN","riverFootstepsGrid":"FlexSuiteRiverFootsteps-module__riverFootstepsGrid__YbvQ5"};